import { createFileRoute, Link } from '@tanstack/react-router'
import WaterCharts from '@/components/field/insights/WaterCharts'
import DateRangePickerWithPresets from '@/components/inputs/DateRangePickerWithPresets'
import { RangeValue, DateValue, Alert, Button } from '@heroui/react'
import { useState } from 'react'
import { parseDate } from '@internationalized/date'
import useFieldDashboard from '@/lib/fieldDashboard/useFieldDashboard'
import Upgrade from '@/components/enrollment/Upgrade'
import { getTodayWithTimeTravel } from '@/lib/utils/date'
import hydroFlowHorizontal from '@/assets/images/HydroFlow_Horizontal_TM.png'
import naveLogo from '@/assets/images/Nave-Transparent-Logo.avif'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSliders } from '@fortawesome/free-solid-svg-icons'

export const Route = createFileRoute(
  '/dashboard/fields/$fieldId/insights/hydroflow/',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { fieldId, fieldIsMonitoring, fieldIsPreview, fieldQuery } =
    useFieldDashboard() ?? {}
  const [dateRange, setDateRange] = useState<RangeValue<DateValue> | null>({
    start: parseDate(
      getTodayWithTimeTravel().subtract(2, 'weeks').format('YYYY-MM-DD'),
    ),
    end: parseDate(
      getTodayWithTimeTravel().add(7, 'days').format('YYYY-MM-DD'),
    ),
  })

  return fieldIsMonitoring || fieldIsPreview ? (
    <div className="flex flex-row gap-2 items-center">
      <Alert
        color="warning"
        variant="flat"
        title="Monitoring Only"
        description="HydroFlow is not available for monitoring enrollments"
      />
      {fieldIsPreview && (
        <Upgrade
          name={
            fieldQuery?.data?.service_provider?.account_manager?.full_name
          }
          email={fieldQuery?.data?.service_provider?.account_manager?.email}
        />
      )}
    </div>
  ) : (
    <div className="flex flex-col gap-2 mt-2">
      <div className="flex flex-row items-center justify-between">
        <div className="flex flex-row items-center gap-4">
          <img
            src={hydroFlowHorizontal}
            alt="HydroFlow"
            className="h-6 w-auto"
          />
          <div className="flex flex-row items-end gap-2 text-sm font-bold">
            Powered by{' '}
            <img src={naveLogo} alt="Nave" className="h-6 w-auto" />
          </div>
        </div>
        <Button
          variant="flat"
          as={Link}
          to={`/dashboard/fields/${fieldId}/insights/hydroflow/settings`}
          size="sm"
          aria-label="HydroFlow Settings"
        >
          <FontAwesomeIcon icon={faSliders} />
          Settings
        </Button>
      </div>
      <DateRangePickerWithPresets
        value={dateRange}
        onChange={setDateRange}
        label="Date Range"
        forecastDays={7}
      />
      <WaterCharts dateRange={dateRange} />
    </div>
  )
}
